import { render, staticRenderFns } from "./inventory-stock-variance.vue?vue&type=template&id=24a5b375&"
import script from "./inventory-stock-variance.vue?vue&type=script&lang=js&"
export * from "./inventory-stock-variance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports